import { getMailRouteStore } from '../store/MailRouteStore';
import { type MailRouteType } from '../schema/MailRouteType';

/**
 * Return the paths array to construct the URL
 * This would be called by the getCurrentRoute method of owa-router
 */
export const getMailRoutePath = (): string[] => {
    const routeStore = getMailRouteStore();

    switch (routeStore.routeType) {
        case 'deeplinkReadItem': {
            return ['read', routeStore.itemId];
        }
        case 'addAccount': {
            return ['add-account'];
        }
        case 'manageAccounts': {
            if (routeStore.itemId) {
                return ['manage-accounts', routeStore.itemId];
            }
            return ['manage-accounts'];
        }

        default:
            return [];
    }
};
